module.exports = __webpack_public_path__ + "static/media/appwrite.a21c9c6e.png";